import {
    addDays, endOfDay, startOfDay, isSameDay, differenceInCalendarDays
} from 'date-fns';

/** Inclusive range ending today, matching the Date Range picker's "Days up to today". */
export function getDaysUpToTodayRange(days) {
    const value = Math.max(Number(days), 1);
    return {
        startDate: addDays(startOfDay(new Date()), (value - 1) * -1),
        endDate: endOfDay(new Date()),
    };
}

export const InputRanges = [
    {
        label: 'Days up to today',
        range(value) {
            return getDaysUpToTodayRange(value);
        },
        getCurrentValue(range) {
            const endOfToday = endOfDay(new Date());
            if (!isSameDay(range.endDate, endOfToday)) return '-';
            if (!range.startDate) return '∞';
            return differenceInCalendarDays(endOfToday, range.startDate) + 1;
        },
    }
];